import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import GenericGridBackground from '@public//images/heros/header-grid-only-desktop.png'
import Image from 'next/image'
import { FC, ReactNode } from 'react'

import { animation } from '@/components/Hero/Hero'
import { RenderOn } from '@/utills/DeviceUtils'

const AnimatedElement = ({ children, index }: { children: ReactNode; index: number }) => {
    return <Box sx={{ ...animation(index) }}>{children}</Box>
}

const Animation = () => {
    const sharedRowStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: '480px',
    }
    return (
        <Box
            sx={{
                width: '45%',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 9,
                flexDirection: 'column',
            }}
        >
            <Box sx={sharedRowStyle}>
                <AnimatedElement index={0}>
                    <Image
                        alt={`chip-img-salesforce`}
                        src={'/images/heros/chip-customers-salesforce.png'}
                        width={288}
                        height={144}
                    />
                </AnimatedElement>
                <AnimatedElement index={1}>
                    <Image
                        alt={`chip-img-salesforce`}
                        src={'/images/heros/chip-customers-payhawk.png'}
                        width={102}
                        height={40}
                    />
                </AnimatedElement>
            </Box>
            <Box
                sx={{
                    ...sharedRowStyle,
                    mr: 3,
                }}
            >
                <AnimatedElement index={2}>
                    <Image
                        alt={`chip-img-gocardless`}
                        src={'/images/heros/chip-customers-gocardless.png'}
                        width={140.69}
                        height={40}
                    />
                </AnimatedElement>
                <AnimatedElement index={3}>
                    <Image
                        alt={`chip-img-visa`}
                        src={'/images/heros/chip-customers-visa.png'}
                        width={288}
                        height={144}
                    />
                </AnimatedElement>
            </Box>
            <Box sx={sharedRowStyle}>
                <AnimatedElement index={4}>
                    <Image
                        alt={`chip-img-forto`}
                        src={'/images/heros/chip-customers-forto.png'}
                        width={288}
                        height={144}
                    />
                </AnimatedElement>
                <AnimatedElement index={5}>
                    <Image
                        alt={`chip-img-salesforce`}
                        src={'/images/heros/chip-customers-ovako.png'}
                        width={98.58}
                        height={40}
                    />
                </AnimatedElement>
            </Box>
        </Box>
    )
}

const CustomersHero: FC = () => {
    const title = 'Our customers grow by building a climate positive legacy'
    const description =
        ' The companies you know and love share how they are accelerating revenue by meeting demand for sustainability with Lune.'
    const content = (
        <Box
            sx={{
                pb: 3,
                pt: 9,
                width: {
                    xs: '100%',
                    md: '65%',
                    lg: '50%',
                },
                height: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: {
                    xs: 'space-between',
                    md: 'center',
                },
                flexDirection: 'column',
                gap: {
                    xs: 4,
                    sm: 4,
                    md: 5,
                    lg: 5,
                    xl: 5,
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                    gap: {
                        xs: 4,
                        sm: 4,
                        md: 5,
                        lg: 5,
                        xl: 5,
                    },
                }}
            >
                <RenderOn breakPoints={['xs', 'sm']}>
                    <Text variant={'h4'}>{title}</Text>
                </RenderOn>
                <RenderOn breakPoints={['xs', 'sm']}>
                    <Text variant={'body2'}>{description}</Text>
                </RenderOn>
                <RenderOn breakPoints={['md', 'lg', 'xl']}>
                    <Text variant={'h3'}>{title}</Text>
                </RenderOn>
                <RenderOn breakPoints={['md', 'lg', 'xl']}>
                    <Text variant={'body1'}>{description}</Text>
                </RenderOn>
            </Box>
        </Box>
    )

    return (
        <Box
            sx={{
                pb: {
                    xs: '440px',
                    md: '0',
                },
                height: {
                    xs: 'auto',
                    md: '792px',
                },
                mt: '-72px !important',
                position: 'relative',
                '.background-image': {
                    height: '100%',
                    width: 'auto',
                    position: 'absolute',
                    left: '-100%',
                    right: '-100%',
                    margin: 'auto',
                    top: 0,
                    zIndex: '-1',
                },
            }}
        >
            <RenderOn breakPoints={['xs', 'sm']}>
                <Image
                    className={'background-image'}
                    width={1800}
                    height={1440}
                    src={'/images/heros/customers-mobile.png'}
                    alt={'page-hero-mobile'}
                />
            </RenderOn>
            <RenderOn breakPoints={['md', 'lg', 'xl']}>
                <Image
                    className={'background-image'}
                    width={4000}
                    height={1584}
                    src={GenericGridBackground}
                    alt={'page-hero-desktop'}
                />
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    {content}
                    <Animation />
                </Box>
            </RenderOn>
            <RenderOn breakPoints={['xs', 'sm']}>{content}</RenderOn>
        </Box>
    )
}

export default CustomersHero
